import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import ArticlesSection from './components/ArticlesSection';
import SocialProof from './components/SocialProof';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SEOSchema from '@/components/feature/SEOSchema';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOSchema
        type="homepage"
        title="Kakobuy Spreadsheet: The Ultimate Resource Center 2026"
        description="Explore the latest Kakobuy Spreadsheet links, best product finds, buying guides, and trusted shopping resources. Updated daily."
        url="https://kakobuy.boutique/"
        dateModified="2026-06-25"
      />
      <Navbar />

      <main>
        {/* Hero */}
        <HeroSection />

        {/* Categories Grid */}
        <CategoryGrid />

        {/* Benefits */}
        <BenefitsSection />

        {/* Comparison Tables */}
        <ComparisonSection />

        {/* Latest Articles */}
        <ArticlesSection />

        {/* Social Proof */}
        <SocialProof />

        {/* About */}
        <AboutSection />

        {/* FAQ */}
        <FAQSection />

        {/* Final CTA */}
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}